module.exports = __webpack_public_path__ + "img/logo-dark.fead3512.png";